import axios from 'axios';

export const api = axios.create({
  baseURL: 'https://api.riggleapp.in',
  headers: {
    'Content-Type': 'application/json',
    'x-app-name': 'retailer',
  }
});

export const getHeaders = () => ({
  'Content-Type': 'application/json',
  'x-app-name': 'retailer',
});

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
      console.error('Network Error:', error);
      throw new Error('Unable to connect to server. Please check your connection.');
    }
    return Promise.reject(error);
  }
);
